import { contactTypesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONTACT_TYPES_ACTION_TYPE = createNamedActions('contact-types', {
  GET_CONTACT_TYPES: 'GET_CONTACT_TYPES',
  CREATE_CONTACT_TYPE: 'CREATE_CONTACT_TYPE',
  UPDATE_CONTACT_TYPE: 'UPDATE_CONTACT_TYPE',
  DELETE_CONTACT_TYPE: 'DELETE_CONTACT_TYPE',
  RESET_CONTACT_TYPES_STATE: 'RESET_CONTACT_TYPES_STATE',
  GET_EDITOR_CONTACT_TYPES: 'GET_EDITOR_CONTACT_TYPES',
  GET_EXTERNAL_CODE_FAMILIES: 'GET_EXTERNAL_CODE_FAMILIES',
});

export const getContactTypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await contactTypesApi.getContactTypes();

  return dispatch({
    type: CONTACT_TYPES_ACTION_TYPE.GET_CONTACT_TYPES,
    payload: data,
  });
});

export const getEditorContactTypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await contactTypesApi.getEditorContactTypes();

  return dispatch({
    type: CONTACT_TYPES_ACTION_TYPE.GET_EDITOR_CONTACT_TYPES,
    payload: data,
  });
});

export const getContactTypeExternalCodesAction = catchAsyncActionError(
  ({ provider }) =>
    async dispatch => {
      const { data } = await contactTypesApi.getExternalCodes(provider);

      return dispatch({
        type: CONTACT_TYPES_ACTION_TYPE.GET_EXTERNAL_CODE_FAMILIES,
        payload: { provider, families: data?.families ?? [] },
      });
    },
);

export const resetContactTypeMappingAction = catchAsyncActionError(
  ({ id, provider }) =>
    async dispatch => {
      await contactTypesApi.deleteContactTypeMapping({ id, provider });

      return dispatch(getEditorContactTypesAction());
    },
);

export const createContactTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await contactTypesApi.createContactType(params);

  return dispatch({
    type: CONTACT_TYPES_ACTION_TYPE.CREATE_CONTACT_TYPE,
    payload: data,
  });
});

export const updateContactTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await contactTypesApi.updateContactType(params);

  return dispatch({
    type: CONTACT_TYPES_ACTION_TYPE.UPDATE_CONTACT_TYPE,
    payload: data,
  });
});

export const deleteContactTypeAction = catchAsyncActionError(id => async dispatch => {
  await contactTypesApi.deleteContactType(id);

  return dispatch({
    type: CONTACT_TYPES_ACTION_TYPE.DELETE_CONTACT_TYPE,
    payload: id,
  });
});

export const resetContactTypesStateAction = () => ({
  type: CONTACT_TYPES_ACTION_TYPE.RESET_CONTACT_TYPES_STATE,
});
